import { render, staticRenderFns } from "./HomeCard.vue?vue&type=template&id=51aa2d99"
import script from "./HomeCard.vue?vue&type=script&lang=js"
export * from "./HomeCard.vue?vue&type=script&lang=js"
import style0 from "./HomeCard.vue?vue&type=style&index=0&id=51aa2d99&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports